import { Box, BoxProps, withDefaults } from 'theme/components';

export default withDefaults<BoxProps>({})(Box);
